import { createContext, useContext } from 'react'

import { BuybackMarkets } from '@/features/circular/buyback'

export interface CircularContextType {
  buybackMarkets: BuybackMarkets
}

export const CircularContext = createContext<CircularContextType>({
  buybackMarkets: null,
})

export const CircularContextProvider = CircularContext.Provider

export const useCircular = () => useContext(CircularContext)
